import React, { Component } from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import './StatisticheContainer.css';


import {
    Container,
    Col,
    Row,
    Button,
    Modal,
    ModalBody,
    timeoutsShape,
    Table
} from 'reactstrap';
import { withRouter } from 'react-router-dom';

class StatisticheContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tokenBI: '',
            reportId:'',
            embedUrl:''
        };

    }

    componentDidMount() {
        fetch("/api/reportId", {
            method: 'GET',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json' 
            }),
            //Changes the response to an object
        }).then(response =>response.text())
        .then(myjson => {
            console.log(myjson)
            
            this.setState({
                reportId: myjson
            })
        }).catch(e => {
        });                     
        
        
        fetch("/api/embedUrl", {
            method: 'GET',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json' 
            }),
            //Changes the response to an object
        }).then(response =>response.text())
        .then(myjson => {
            console.log(myjson)
            
            this.setState({
                embedUrl: myjson
            })
        }).catch(e => {
        });                     
        
        fetch("/api/tokenBI", {
            method: 'GET',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json' 
            }),
            //Changes the response to an object
        }).then(response =>response.text())
        .then(myjson => {
            console.log(myjson)
            
            this.setState({
                tokenBI: myjson
            })
        }).catch(e => {
        });                     
    }
    
    render() {
        return (
            <Container className="d-flex align-items-center justify-content-center" style={{ paddingBottom: "15px" }} fluid>
               
            <iframe title="DigarBI - 5 Fatturato medio per ordine" width="1140" height="541.25" src= {this.state.embedUrl} frameborder="0" allowFullScreen="true"></iframe>



              
            </Container>
        )
    }
}
export default withRouter(StatisticheContainer)



/*<iframe width="1140" height="541.25" src="https://app.powerbi.com/reportEmbed?reportId=91911312-bd5c-4f02-b4ba-274fbba28585&autoAuth=true&ctid=f9acc349-54dc-4ca8-bbe6-8f06e2b17ed3&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtZXVyb3BlLWUtcHJpbWFyeS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldC8ifQ%3D%3D" frameborder="0" allowFullScreen="true"></iframe>
'H4sIAAAAAAAEAB2XtQ7tSBZF_-WlbslMLXVguGbGa2dmZvZo_n3udFLRCUpLtdc-9Z8_VvL0U5L_-fuPlAnnyhdOxvYPYafindceGWl3hhNS1WXyx9J5AeagwsLYZ-O6RNyRmVIrEnIi2uhCN7BXAoYtt9_9qQK7ZTp6U4exJBQPv1bPEFnOa82_18K-Nyj6oSmhD5xbJ34pH9AZ6QHqZie6BxmG9gyptM_7nOmVNIbU7hzgHn0ABL_jsszzqyC-rjRVZ2EFNZ2uzPLrtmkXxajIXWAFXgHfHGCCGpHsSezutn9e01T5TzzTz5aVWOVexUR_IexTg4ni1jkzUzxlpmeGhADZ-lMwc_I530XuqVNd-RgcaZeTJ6QjrusSLf4EfG0OH2D9y6NL-NgpVG6DcKaYRWB4Z0Qm109aNoGBFtur2UKdRz3IC2zHA6gkZAGzVEpaTg4k2vPuNlVzeRbe98tWWsQXdJ0e-amsgz6pI7ItNozYFL-TjeCKnBmxZPKZ60tY62Ng2Ho9Mxtcc90Rfeejq9p3u-DBOqKvty-sHcZPxHEkCbiDfzgqvgyzKSBkkyMuR1peLfIygQevN6YrZFo8WpRbXdsraWFt0zjL3Lcgjk1PJFOVkx58ZyK2TVkK6SUcGLa21hs9jbbc-EG06sGXT8uth9c6gYy9rSscdjxv2PyQE3cGrkPgtRDWViVfhlOngCxjNqFZ1MqFFP5OX0d4lhoxzRuw-lF8F7of46N_jiCr6KDvgQxcfLfdp_sxIMTYGn9XNZHKyMiBZ2IHEUfhPnjIrOnAq_XOL0vdgVebzjkxvm_xkT-Cmq0iO7tUrNoz7O1UfYRLFbhg2dXKTeEIkGFuBDrHe3BZCSVgimBT5jIoQPguoF-2ivSA8zJb3BGbsYyOsnluH1iQOaZFBEXbk5HiPLAHIJF7_xQo9207IKWUB1GiGt62JsSgb_WJHbqHdAFg0dXlxGfTncrEWRxKlO5m7F6GCOley9o5PhpRvUd40MJ0tu0rdy57mbGdAsDpy05ez51pHK3ceQmkdZkphone0jESd6wCdnLOo-ccHlA6kgA8fcfS9zvZUOHy0KTq9CtLKtNPjoxsCyXMd1QL_QfDx9DYzGSKZaRIGo2VO_ujbPSrMT27Vfjz5E-9LAgN76mVIkCHi7lfgkQWenx78eZGm0SSGna3FAz5PMhV3jOYfBToWzJUoBfG9YWkRwUoi3FeDV6A0yWLJcow1vVCGU0z4P64pU-8IBum8eZkJYjKjj1Gy0YmvX2lZtR2Uh6LHGEJZA6FHV8xV28oyOm1MUaTpD6GzUZji1LE_a68HO_JszIS9TvOqM8BCOZOWmvXGWf1e-3Mh11JEu-zPMi4zBDliflEySTHFRXc9KCrNhOLIyw4HngHl6xegE2A9BDyPGOm81znuazKJ99uyqrSlfLpoBNlMMnXBGBpEYC6Zvz7lq72SpkOKglTJDecr4Ixj9sVBqKUhYaJmIZJ276zye2niESS9Tm9i8uYlKupNG2C0aK2OIHirjE3CQ9A4CfJQL9weIswwIO3RZH3xvKxlWzNAYlnc9KMZPkLL-y4RaCXhMTEI8SBIPr6HXPtT9qT1zOgLoP7ISL7-qgF7H00HM7ie40v3abHBJSFBFrRCaO_KlnadfWRzCQR8GT1Si5V3ev9RfGsuEXevM_1qAbCIE4txzMzhx-XHw6eXVex0pX5OxlG6Gl-6cboV-S_dspMAgL5hgB2YQBXAvANUywLhVHwlWnNNi3TH6erZaMcb8jU9RGNC8hWQTDSk4LlsRZwW0rSCVTlLkOQ5sDx3ADj3qHW1-OMWmheHK_Te88V-xE4Fct88uhJGYfjX-XTi4UgCVmxQl-1YeZa0DY-T_dN3yS_rryDpacAv886WwsxNCbp8aigpqls6l90Ej7GlVkWVD9h0oIv7muW4PTNIw-nwynexgfDmECbOWqWASM4vQ6UqYfQ09yGTtboDQY9mM1tJS4fe8yVfOic9C4_-rHiME-zdXKUIjUQ0-3PfeZLDfuBtxYVW6w5BuDnhHcGgz0cbzQeLWbbyIgxhIfR8FqkeR_1Ptin8_ztRn0NMYND2aZphix6dxxdvp6wcKNyOmScEngR1QNB65GGvuRVv3BwxCKqWigRgEDJQXRSa6gQvscycogwg6K1PGlDl1aTNpgZ7c_ozvKscssXdY8LD1mMCGPG35unFhErs-5XahU0mEcde2qUrE3ictDa14-NxX5eOklkvp8AEoStOU2kUdWHNNatJVz8ZB2E__m0__By3uQOXpv-NC4sSvWuSZ9VxYNJ-8nlbHU0edw96dbsUYB9hKVctRXk2l6ome7Jsu9-T3BZf6zfqH1J7tWpnHy2WSH2J20Ncqwsv6MONfoAk01K8N0JdFSQrSTUWXot-IrqDLGpaB31yNFNTfTVrbOXV3IT5CLb9dsY2Fz9LmfbnSlrqEIl80FVxUTa4FyfGa1BceBNYeDjBuChL57LdS4zDn6zHjXRuA-by5LJixueFL8AYgoPYQYnlgEKdap5JuPm1V8x2o5pilJtoMQ3rJj1hjudgCenUE2vVJFdfOxxazFbVuTscHcXteAqdiSRe-KiM4ZJg39EeBRCJL7lxRtjjK290_ZB6UdP807Lhn5csrvPGLFGEizmRLaAxzdeJ9tvQ3PQtG8mLINGfX5GxQJWGWdW9nlj11No947KK4Qju1EIBUabaVbvuceX5sWgpzhqtk1-VToUk2Qd01z6ce5Gv8vpnz9__eHWZ94ntXh-q6dssic3gE2Oq_dqyzeKsu30yzg6V_Pa8mEIAmdw22fP9VYlidgn1DsgLMSV5sqf1IjcXSaxsiNUA98uwNi3rqNfwKigG5tnaObmxar2uycmWbwBrxSWYQ0imiba4XRaUx2xtswhvHmqJIq_PEmLxpoyG2B2ZKoUZYfT0P9wWS2leA8R2KLhf1lfnRkILszMncxn5VLYZaDJB_3S44OOy_awduz9YkXpEkGxy7rf4nJCPWgyude79oQFNLyG7Jks11uUAdGrS98LPux98akZg1lJbwKyLTJZY-T50FtFzCQbbiiGt5sPD97QmbHlaLCZXJDyzTzebVZXMTKFTo0KMWA8vv75F_Mz18UqBz_KJCWVwLFPqDzp4NSiRvqIG_PvlNtUY7Ifa_Ebg2BNbeL-TrMt_X0ENNzAAaE8FVhOsDNa_ekEfx2GMxDe8cIS4hIi2s_QYiAlPi8g1sV3D_s9qMq0JIe4O4Rf-xaugn9BLGJ7Y2B40j6PZKvfc_4ocA1TYSmIw2_XmFYHOxSfmIyT-N2aRYkBRmFNBl_Q1oWQn2x0mZjU5L7kjuVidKMcvzUIC4fbh6yNb3vIfn-fQFm6XnyOVHmOlwygEmchxP2rkp-U30yKZy6nq5VHKzM5zlnbbDnC20W4pf0F-0jfnwIhjF7LWalkJ709sh5GLBbN9l_v3Sru6G0IW2ZiLpiX1kgMXYxGDd6yfc_saAmUznLw4XkcbgvYSmWTL0rN_j_m__4P8g4CQ24NAAA=.eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVdFU1QtRVVST1BFLUUtUFJJTUFSWS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCIsImVtYmVkRmVhdHVyZXMiOnsibW9kZXJuRW1iZWQiOmZhbHNlfX0=',


<PowerBIEmbed
embedConfig={{
    type: 'report',   // Supported types: report, dashboard, tile, visual and qna
    id: undefined,//this.state.reportId,
    embedUrl: 'https://app.powerbi.com/reportEmbed?reportId=212fa2be-b6a7-4560-a63d-e96392592f8c&autoAuth=true&ctid=14018ef9-837f-4e7b-960e-c1067ed8a608&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtZXVyb3BlLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9',//this.state.embedUrl,
    accessToken: undefined,//this.state.tokenBI,
    tokenType: models.TokenType.Embed,
    settings: {
        panes: {
            filters: {
                expanded: false,
                visible: true
            }
        },
        
    }
}}

eventHandlers={
    new Map([
        ['loaded', function () { console.log('Report loaded'); }],
        ['rendered', function () { console.log('Report rendered'); }],
        ['error', function (event) { console.log(event.detail); }]
    ])
}

cssClassName={"Embed-container"}

getEmbeddedComponent={(embeddedReport) => {
    window.report = embeddedReport;
}}
/>*/



// WEBPACK FOOTER //
// ./src/containers/StatisticheContainer.js